module.exports = __webpack_public_path__ + "static/07-030c63e2f0e1d442c9908f54d03ab949.jpg";